import React from "react";
import SectionHeader from "@/components/shared/SectionHeader";
import { EXPERIENCE_ITEMS, EISG_IMG } from "@/lib/data";

const EISGExperience = () => (
  <div>
    <section className="relative py-32 lg:py-40 overflow-hidden">
      <div className="absolute inset-0">
        <img src={EISG_IMG.capeTown} alt="Cape Town" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F]/95 via-[#0A192F]/75 to-[#0A192F]/30" />
      </div>
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 text-white">
        <div className="overline text-[#D4AF37] mb-6">— Experience</div>
        <h1 className="font-eisg text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02] max-w-4xl">
          Plus qu'une formation, <span className="text-[#D4AF37] italic">une expérience de leadership.</span>
        </h1>
      </div>
    </section>

    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader number="— 01" eyebrow="L'expérience EISG" title="Dix dimensions d'une immersion exécutive premium." titleFont="eisg" />
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#0A192F]/10">
          {EXPERIENCE_ITEMS.map((e, i) => (
            <div key={e.title} className="bg-white p-8 lift-card relative overflow-hidden group">
              <div className="absolute -top-2 -right-2 font-eisg text-7xl text-[#0A192F]/5 group-hover:text-[#D4AF37]/15 transition-colors">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="section-num">— {String(i + 1).padStart(2, "0")}</div>
              <h3 className="mt-4 font-bd text-xl text-[#0A192F] tracking-tight">{e.title}</h3>
              <p className="mt-3 text-[#0A192F]/70 text-sm leading-relaxed">{e.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-24 bg-[#FAFAFA]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-10">
        <div>
          <img src={EISG_IMG.executives} alt="EISG" className="w-full h-[460px] object-cover" />
        </div>
        <div className="flex flex-col justify-center">
          <p className="font-eisg text-3xl sm:text-4xl lg:text-5xl text-[#0A192F] tracking-tight leading-[1.1]">
            Une cohorte EISG, c'est <span className="text-[#F58220] italic">une communauté de dirigeants africains.</span>
          </p>
          <p className="mt-6 text-[#0A192F]/75 text-lg leading-relaxed">
            Réseau, immersion, coaching, cas pratiques et expériences culturelles : EISG conçoit chaque cohorte comme un moment de transformation personnelle et institutionnelle.
          </p>
        </div>
      </div>
    </section>
  </div>
);

export default EISGExperience;
